// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xXnhl3yQUdgYhUppl1NR{flex-direction:column;flex-grow:1;display:flex;position:relative}.UbERjNUCqeYijVQGA0C4{align-items:center;gap:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `xXnhl3yQUdgYhUppl1NR`,
	"headerName": `UbERjNUCqeYijVQGA0C4`
};
export default ___CSS_LOADER_EXPORT___;
